<template>
    <v-form
    v-on:submit.prevent="filtrar"
    ref="formFiltro" class="filtros-acordos">
        <v-divider class="mt-2 mb-3"></v-divider>
        <v-row>
            <v-col sm="6" md="4" lg="3" class="pb-0">
                <MesInput
                    label="Período Inicial"
                    v-model="filtro.mesInicial"
                    :rules="regra.mesInicial"
                    :change="periodoInicialChange"
                    required
                ></MesInput>
            </v-col>
            <v-col sm="6" md="4" lg="3" class="pb-0">
                <MesInput
                    label="Período Final"
                    v-model="filtro.mesFinal"
                    :rules="regra.mesFinal"
                    :change="periodoFinalChange"
                    required
                ></MesInput>
            </v-col>
            <v-col sm="6" md="4" lg="3" class="pb-0">
                <v-text-field
                    label="Número do acordo"
                    outlined
                    dense
                    class="input-cinza"
                    v-model="filtro.id_acordo"
                ></v-text-field>
            </v-col>
            <v-col sm="6" md="4" lg="3" class="pb-0">
                <v-text-field
                    label="Número do acordo RD"
                    outlined
                    dense
                    class="input-cinza"
                    v-model="filtro.acordo_rd"
                ></v-text-field>
            </v-col>
        </v-row>
        <v-expansion-panels flat v-model="mostrarFiltros" accordion>
            <v-expansion-panel>
                <v-expansion-panel-content eager class="p-0 m-0">
                    <v-row>
                        <v-col sm="6" md="4" lg="3" class="pb-0">
                            <v-text-field
                                label="Número do contrato"
                                outlined
                                dense
                                class="input-cinza"
                                v-model="filtro.id_contrato"
                            ></v-text-field>
                        </v-col>
                        <v-col sm="6" md="4" lg="3" class="pb-0">
                            <v-text-field
                                label="Número do contrato RD"
                                outlined
                                dense
                                class="input-cinza"
                                v-model="filtro.contrato"
                            ></v-text-field>
                        </v-col>
                        <v-col sm="6" md="4" lg="3" class="pb-0">
                            <SelectInput
                                label="Bandeira"
                                v-model="filtro.bandeira"
                                :items="lista.bandeira"
                                multiple
                                :menu-props="menuProps"
                                outlined
                                dense
                                class="input-cinza"
                                :show-select-all="true"
                            >
                            </SelectInput>
                        </v-col>
                        <v-col sm="6" md="4" lg="3" class="pb-0">
                            <SelectInput
                                label="Espaço"
                                v-model="filtro.id_espaco"
                                :items="computedEspaco"
                                multiple
                                outlined
                                dense
                                class="input-cinza"
                                show-select-all
                            >

                            </SelectInput>
                        </v-col>
                        <v-col sm="6" md="4" lg="3" class="pb-0">
                                <SelectInput
                                label="Espaço Macro"
                                v-model="filtro.espaco_macro"
                                :items="lista.espaco_macro"
                                multiple
                                :menu-props="menuProps"
                                outlined
                                dense
                                class="input-cinza"
                                show-select-all
                            >
         
                            </SelectInput>
                        </v-col>
                        <v-col sm="6" md="4" lg="3" class="pb-0">
                            <SelectInput
                                label="Fornecedor"
                                v-model="filtro.id_fornecedor"
                                :items="lista.fornecedor"
                                multiple
                                :menu-props="menuProps"
                                outlined
                                 :show-select-all="true"
                                dense
                                class="input-cinza"
                            >

                            </SelectInput>
                        </v-col>
                        <v-col sm="6" md="4" lg="3" class="pb-0">
                            <SelectInput
                                label="Macro Fornecedor"
                                v-model="filtro.id_macrofornecedor"
                                :items="lista.macrofornecedores"
                                multiple
                                :menu-props="menuProps"
                                outlined
                                 :show-select-all="true"
                                dense
                                class="input-cinza"
                            >

                            </SelectInput>
                        </v-col>
                        <v-col sm="6" md="4" lg="3" class="pb-0">
                            <SelectInput
                                label="Status"
                                :items="listaStatus"
                                v-model="filtro.id_status"
                                multiple
                                :menu-props="menuProps"
                                outlined
                                dense
                                class="input-cinza"
                                show-select-all
                            >

                            </SelectInput>
                        </v-col>
                        <v-col sm="6" md="4" lg="3" class="pb-0">
                            <SelectInput
                                label="Cluster"
                                :items="lista.cluster"
                                v-model="filtro.id_cluster"
                                multiple
                                :menu-props="menuProps"
                                outlined
                                dense
                                :show-select-all="true"
                                class="input-cinza"
                            >
                              
                            </SelectInput>
                        </v-col>
                        <v-col sm="6" md="4" lg="3" class="pb-0">
                            <SelectInput   
                                label="Acordo por Região"
                                :items="lista.regiao"
                                v-model="filtro.regiao"
                                multiple
                                :menu-props="menuProps"
                                outlined
                                dense
                                class="input-cinza"
                                show-select-all
                            >
          
                            </SelectInput>
                        </v-col>
                        <v-col sm="6" md="4" lg="3" class="pb-0">
                            <v-text-field
                                label="Número do lote"
                                outlined
                                dense
                                class="input-cinza"
                                v-model="filtro.id_lote"
                            ></v-text-field>
                        </v-col>
                        <v-col sm="6" md="4" lg="3" class="pb-0">
                            <SelectInput
                                label="Usuario"
                                v-model="filtro.id_usuario"
                                :items="lista.usuarios"
                                multiple
                                :menu-props="menuProps"
                                outlined
                                dense
                                class="input-cinza"
                                show-select-all
                            >
                              
                            </SelectInput>

                            
                        </v-col>
                        <v-col sm="6" md="4" lg="3" class="pb-0">
                            <v-select
                                label="Visível"
                                v-model="filtro.visivel"
                                :items="['Sim','Não']"
                                :menu-props="menuProps"
                                outlined
                                dense
                                class="input-cinza"
                            >
                            </v-select>
                        </v-col>
                       
                        
                    </v-row>
                </v-expansion-panel-content>
            </v-expansion-panel>
        </v-expansion-panels>
        <v-divider class="mt-0 mb-3"></v-divider>
        <v-row>
            <v-col cols="3" class="px-2 ml-auto">
                <div class="new-button d-flex align-center" text>
                    <span @click="expandirFiltros" style="cursor: pointer"
                        >Personalizar Filtros</span
                    >
                    <v-btn
                        style="background: #e6e6e6; width: 20px; height: 20px"
                        fab
                        icon
                        class="ml-3"
                        @click="expandirFiltros"
                        x-small
                    >
                        <v-icon>{{
                            mostrarFiltros == 0
                                ? "mdi-chevron-up"
                                : "mdi-chevron-down"
                        }}</v-icon>
                    </v-btn>
                </div>
            </v-col>
            <v-col cols="9" class="ml-auto" align="end">
                <v-btn
                    class="ml-2 new-button"
                    color="yellow"
                    dark
                    @click="limpar()"
                >
                    <v-icon left>mdi-filter-off</v-icon> Limpar Filtros
                </v-btn>
                <v-btn
                    class="ml-5 new-button"
                    color="primary"
                    type="submit"
                >
                    <v-icon left>mdi-filter</v-icon> Filtrar
                </v-btn>
            </v-col>
        </v-row>
        <v-overlay :value="carregando">
            <v-progress-circular indeterminate size="64"></v-progress-circular>
        </v-overlay>
        
    </v-form>
</template>

<script>
import useFiltros from "../../hooks/useFiltros";

export default {
    setup() {
        const { isLoading, isError, isFetching, lista, error, refetch } =
            useFiltros("/acordo/listaCampos");

        return { isLoading, isError, isFetching, lista, error, refetch };
    },
    // inject: ["listaCampos"],
    data() {
        return {
            carregando: false,
            mostrarFiltros: null,
            menuProps: {
                bottom: true,
                offsetY: true,
                contentClass: "select-outline",
                transition: "slide-y-transition",
            },
        
            filtro: { },
            regra: {
                mesInicial: [
                    (v) =>
                        (this.filtro.tipoPeriodo < 1 && !!v) ||
                        "O campo período inicial é obrigatório",
                ],
                mesFinal: [
                    (v) =>
                        (this.filtro.tipoPeriodo < 1 && !!v) ||
                        "O campo período final é obrigatório",
                    (v) =>
                        (this.filtro.tipoPeriodo < 1 &&
                            !!v &&
                            v >= this.filtro.mesInicial) ||
                        "O período final deve ser igual ou posterior ao período inicial",
                ],
            },
        };
    },
    async created() {
        // this.carregando = true;
        // var lista = await this.listaCampos;
        // lista.status = lista.status.sort(function (a, b) {
        //     return a.text.localeCompare(b.text);
        // });
        // this.lista.bandeira = lista.bandeira;
        // this.lista.espaco = lista.espacoFiltro;
        // this.lista.espaco_macro = lista.espaco_macro;
        // this.lista.fornecedor = lista.fornecedor;
        // this.lista.status = lista.status;
        // this.lista.cluster = lista.cluster;
        await new Promise((resolve) => setTimeout(resolve, 100));
        this.iniciaFiltro();
        // this.carregando = false;
    },
    computed: {
      
        listaStatus() {
            if(!this.lista.status) return[];
            return [...this.lista.status].sort(function (a, b) {
            return a.text.localeCompare(b.text);
        });
        },
        computedEspaco() {
            if(!this.lista.espaco || !this.lista.espacoSomenteLeitura) return [];
            return [...this.lista.espaco, ...this.lista.espacoSomenteLeitura].sort(function (a, b) {
                return a.text.localeCompare(b.text);
            });
        },
    },
    watch: {
        "lista.fornecedor": {
            handler: function (val, oldVal) {
                    if (this.lista.fornecedor.length == 1) {
                        this.filtro.id_fornecedor = [this.lista.fornecedor[0].value];
                    }
            },
            deep: true,
        },
    },
    methods: {
        iniciaFiltro() {
            this.filtro = {
                mesInicial: this.$moment().format("YYYY-MM"),
                mesFinal: this.$moment().format("YYYY-MM"),
                tipoPeriodo: -1,
                id_acordo: null,
                id_acordo_rd: null,
                id_contrato: null,
                 contrato: null,
                bandeira: [],
                id_espaco: [],
                espaco_macro: [],
                id_fornecedor: [],
                id_status: [],
                id_usuario: [],
                id_cluster: [],
                planograma: [],
                visivel: null,
                id_macrofornecedor: [],
            };
         
        },
        limpar() {
            this.iniciaFiltro();

            this.$emit("limpar");
        },
        filtrar() {
            this.$emit("filtrar");
        },
        validate() {
            return this.$refs.formFiltro.validate();
        },
        expandirFiltros() {
            this.mostrarFiltros = this.mostrarFiltros == 0 ? null : 0;
        },
        periodoInicialChange(valor) {
            if (this.filtro.mesFinal < valor) {
                this.filtro.mesFinal = valor;
            }
        },
        periodoFinalChange(valor) {
            if (this.filtro.mesInicial > valor) {
                this.filtro.mesInicial = valor;
            }
        },
        resetValidation() {
            try {
                this.$refs.formFiltro.resetValidation();
            } catch (error) {
                //console.log(error)
            }
        },
    },
};
</script>
